export const SKELETON_SHAPES = {
    RECTANGLE: 'rectangle',
    CIRCLE: 'circle',
    TEXT: 'text',
  };

export const SKELETON_MOTION = {
    PULSE: 'pulse',
    WAVE: 'wave',
}